export enum Ratios {
  '9:16' = '9:16',
  //   '3:4' = '3:4',
  '4:3' = '4:3',
  '16:9' = '16:9',
}
